type iconParam = {
    iconClass: string,
    divClass?: string
};

const Icon = (props: iconParam) => {
    return(
        <div className={`icon ${props.divClass? props.divClass: ''}`}>
            <span className={props.iconClass}></span>
        </div>
    )
}

export default Icon;
